/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-05-13 13:27:23
 * @LastEditors: wl
 * @LastEditTime: 2020-06-05 09:28:08
 */ 
import axios from '../axios'


/* 
 * 系统登录模块
 */

// 登录
// export const login = data => {
//     return axios({
//         url: 'login',
//         method: 'post',
//         data
//     })
// }
export const login = data => {
       
        return axios({
           // url: '/admin/service/authLogin',//薛军
             url: '/admin/service/sys_login',//强哥
            method: 'post',
            data
        })
    }

// 登出
export const logout = () => {
    return axios({
        url: 'logout',
        method: 'get'
    })
}
// 服务通告
export const list_notice_nocheck = data => {
    return axios({
        url: '/admin/service/list_notice_nocheck',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/login.js